import { render, staticRenderFns } from "./Percent.vue?vue&type=template&id=45e042e7&"
import script from "./Percent.vue?vue&type=script&lang=ts&"
export * from "./Percent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports